import { render, staticRenderFns } from "./ChatListItem.vue?vue&type=template&id=490e3b64&scoped=true&"
import script from "./ChatListItem.vue?vue&type=script&lang=js&"
export * from "./ChatListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatList.scss?vue&type=style&index=0&id=490e3b64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e3b64",
  null
  
)

export default component.exports